/**
 * Reports menu: category hubs under /home/reports/:sectionId and leaf reports under /home/reports/:slug
 */

/** @type {{ id: string, navLabel: string, iconName: string, cards: { slug: string, label: string }[] }[]} */
export const REPORT_SECTIONS = [
  {
    id: 'order-reports',
    navLabel: 'Order Reports',
    iconName: 'ShoppingCart',
    cards: [
      { slug: 'order-report', label: 'Order Report' },
      { slug: 'pending-orders', label: 'Pending Orders' },
      { slug: 'advance-orders', label: 'Advance Orders' },
    ],
  },
  {
    id: 'pickup-reports',
    navLabel: 'Pickup Reports',
    iconName: 'ClipboardList',
    cards: [
      { slug: 'client-pickup-request-report', label: 'Client Pickup Request Report' },
      { slug: 'customer-pickup-request-report', label: 'Customer Pickup Request Report' },
    ],
  },
  {
    id: 'delivery-reports',
    navLabel: 'Delivery Reports',
    iconName: 'Truck',
    cards: [{ slug: 'delivery-report', label: 'Delivery Reports' }],
  },
  {
    id: 'shipment-reports',
    navLabel: 'Shipment Reports',
    iconName: 'Package',
    cards: [
      { slug: 'shipment-report', label: 'Shipment Report' },
      { slug: 'shipment-expense-report', label: 'Shipment Expense Report' },
    ],
  },
  {
    id: 'clients-reports',
    navLabel: 'Clients Reports',
    iconName: 'Building2',
    cards: [
      { slug: 'inactive-clients', label: 'Inactive Clients' },
      { slug: 'client-orders', label: 'Client Wise Orders' },
    ],
  },
  {
    id: 'customer-reports',
    navLabel: 'Customer Reports',
    iconName: 'Users',
    cards: [{ slug: 'customer-orders', label: 'Customer Wise Orders' }],
  },
  {
    id: 'employee-reports',
    navLabel: 'Employee Reports',
    iconName: 'UserCheck',
    cards: [
      { slug: 'driver-commission', label: 'Driver Commission' },
      { slug: 'employee-orders', label: 'Employee Wise Orders' },
      { slug: 'employee-timeline', label: 'Employee Timeline' },
      { slug: 'driver-expense', label: 'Driver Expense' },
    ],
  },
  {
    id: 'agent-reports',
    navLabel: 'Agent Reports',
    iconName: 'UserCog',
    cards: [{ slug: 'agent-orders', label: 'Agent Wise Orders' }],
  },
  {
    id: 'expense-reports',
    navLabel: 'Expense Reports',
    iconName: 'Receipt',
    cards: [
      { slug: 'company-expense', label: 'Company Expense' },
      { slug: 'driver-expense', label: 'Driver Expense' },
      { slug: 'shipment-expense-report', label: 'Shipment Expense Report' },
    ],
  },
  {
    id: 'payment-reports',
    navLabel: 'Payment Report',
    iconName: 'DollarSign',
    cards: [{ slug: 'client-payment-report', label: 'Client Payment Report' }],
  },
  {
    id: 'return-reports',
    navLabel: 'Return Report',
    iconName: 'RotateCcw',
    cards: [{ slug: 'client-return-report', label: 'Client Return Report' }],
  },
  {
    id: 'financial-reports',
    navLabel: 'Financial Reports',
    iconName: 'TrendingUp',
    cards: [
      { slug: 'income-expense', label: 'Income Expense' },
      { slug: 'vat-report', label: 'Vat Report' },
    ],
  },
];

/** Sidebar: one row per category (opens hub). */
export const REPORT_NAV_ITEMS = REPORT_SECTIONS.map((s) => ({
  slug: s.id,
  label: s.navLabel,
  iconName: s.iconName,
}));

export function getReportSectionById(id) {
  return REPORT_SECTIONS.find((s) => s.id === id) ?? null;
}

const labelEntries = () => {
  const pairs = [];
  for (const s of REPORT_SECTIONS) {
    pairs.push([s.id, s.navLabel]);
    for (const c of s.cards) {
      pairs.push([c.slug, c.label]);
    }
  }
  return pairs;
};

export const REPORT_LABEL_BY_SLUG = Object.fromEntries(labelEntries());

export const REPORT_PATH_LABELS = Object.fromEntries(
  Object.keys(REPORT_LABEL_BY_SLUG).map((slug) => [`/home/reports/${slug}`, REPORT_LABEL_BY_SLUG[slug]])
);
